import React from "react"
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material"
import { useFormikContext } from "formik"
import i18n from "@/i18n"
import { getLargeGroupThresholds } from "@/constants/reservation_rules"
import { SETTINGS_SECTION_STYLES } from "@/components/settings/_styles"

const STYLES = {
  ...SETTINGS_SECTION_STYLES,
} as const

const LargeGroups: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const largeGroupThresholds = getLargeGroupThresholds()

  return (
    <div className={STYLES.container} data-testid="settings-venue-rules-large-groups-container">
      <h2 className={STYLES.header}>{i18n.t("app.settings.venues.reservation_rules.large_groups.title")}</h2>
      <FormControl fullWidth>
        <InputLabel id="large-group-label">
          {i18n.t("app.settings.venues.reservation_rules.fields.large_group_threshold")}
        </InputLabel>
        <Select
          labelId="large-group-label"
          label={i18n.t("app.settings.venues.reservation_rules.fields.large_group_threshold")}
          value={values.largeGroupThreshold}
          onChange={(e) => setFieldValue("largeGroupThreshold", e.target.value)}
          data-testid="settings-venue-rules-large-groups-select"
        >
          {largeGroupThresholds.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText className="text-gray-500">
          {i18n.t("app.settings.venues.reservation_rules.helpers.large_groups")}
        </FormHelperText>
      </FormControl>
    </div>
  )
}

export default LargeGroups
